module.exports = __webpack_public_path__ + "img/z (20).d7452ed9.png";